import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    fetchProject, fetchDrivers, fetchDriverOpmodesSelected, fetchDriverFeatures, fetchDriverProperties,
    generateProject, setTemporaryProject,
    updateProject, verifyProject, downloadProject,
    updateDriverOpmodesSelected,
    resetProject, resetDriver,
    propertiesWorker, copyProject, getProjectOptions, putProjectOptions
} from '../../../actions';
import { addRecentProject, removeRecentProject } from '../../../utils/recentProjectsUtility';
import ProjectPlaceholder from './ProjectPlaceholder';
import { Button, Modal, Spinner, Col, Form } from 'react-bootstrap';
import ProjectHeader from './projectShow/ProjectHeader';
import ProjectSummary from './projectShow/projectSummary/ProjectSummary';
import ProjectDriver from './projectShow/projectDriver/ProjectDriver';
import DeviceSelect from './deviceSelect/DeviceSelect';
import ReworkKeyForm from './projectShow/projectDriver/projectProperties/components/ReworkKeyForm';
import { X_API_KEY } from '../../../utils/authentication';
import Radio from 'components/shared/StandaloneRadio';
import { Trans, withTranslation } from 'react-i18next';

class Project extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            driver: Object.assign({}, this.props.driver),
            // projectName: '',
            projectOrderCode: '',
            projectDescription: '',
            projectCustomer: '',
            newProjectNameForCopy: '',
            projectErrors: {
                name: false,
            },
            options: {
                isProtected: true,
                reworkKey: "",
                lockSetup: false,
                verify: false,
                disableFamilyProgramming: false,
                programAs: "master"
            },
            checkedFeatures: [],
            driverProperties: [],
            disabled: false,
            disabledDriver: false,
            disabledClassName: '',
            isShowingWarningDownloadApiKey: false,
            isShowingWarningDownloadPassword: false,
            isShowingWarningNewProject: false,
            isShowingWarningErrors: false,
            isShowingDriverAdd: false,
            isShowingProgrammingOptions: false,
            isShowingDeleteProjectForDemo: false,
            isShowingWarningOpMode: false,
            lastButtonClicked: null,
            keyType: null,
            reworkKeyType: "default"
        };
        this.handleChangeProjectInfo = this.handleChangeProjectInfo.bind(this);
        this.openCopyProjectPopup = this.openCopyProjectPopup.bind(this);
        this.tryToOpenCopyProjectPopup = this.tryToOpenCopyProjectPopup.bind(this);
        this.copyProject = this.copyProject.bind(this);
        this.saveAndDownloadProject = this.saveAndDownloadProject.bind(this);
        this.saveProject = this.saveProject.bind(this);
        this.tryToDownloadProject = this.tryToDownloadProject.bind(this);
        this.downloadProject = this.downloadProject.bind(this);
        this.validateConfigLock = this.validateConfigLock.bind(this);
        this.handleChangeOperatingMode = this.handleChangeOperatingMode.bind(this);
        this.handleChangeNewProjectName = this.handleChangeNewProjectName.bind(this);
        this.handleChangeProgrammingOptions = this.handleChangeProgrammingOptions.bind(this);
        this.handleCheckedFeatures = this.handleCheckedFeatures.bind(this);
        this.handleChangeDriverProperties = this.handleChangeDriverProperties.bind(this);
        this.handleCloseModalApiKey = this.handleCloseModalApiKey.bind(this);
        this.handleCloseModalPassword = this.handleCloseModalPassword.bind(this);
        this.handleCloseModalNewProject = this.handleCloseModalNewProject.bind(this);
        this.handleCloseModalErrors = this.handleCloseModalErrors.bind(this);
        this.handleCloseModalProgrammingOptions = this.handleCloseModalProgrammingOptions.bind(this);
        this.handleCancelModalProgrammingOptions = this.handleCancelModalProgrammingOptions.bind(this);
        this.handleCloseModalDeleteProjectForDemo = this.handleCloseModalDeleteProjectForDemo.bind(this);
        this.toggleModalDriverAdd = this.toggleModalDriverAdd.bind(this);
    }

    componentDidMount() {
        const { t } = this.props;
        // Fetch of the project
        this.props.fetchProject(this.props.match.params.id)
            .then(() => {

                this.setState({
                    // projectName: this.props.project.name !== null ? this.props.project.name : '',
                    projectOrderCode: this.props.project.orderCode !== null ? this.props.project.orderCode : '',
                    projectDescription: this.props.project.description !== null ? this.props.project.description : '',
                    projectCustomer: this.props.project.customer !== null ? this.props.project.customer : '',
                    saveProjectButtonText: t('Download'),
                    copyProjectButtonText: !this.projectIsTemporary() ? t('Save_as') : t('Rename'),
                    saveAsNewProjectModalText: t('Save'),
                }, () => {
                    addRecentProject(this.getEditedProject());
                });
            })
            .catch(err => {
                console.error(err);
                removeRecentProject(this.props.match.params.id);
                this.props.history.push('/');
            });

        // Fetch of the project options
        this.props.getProjectOptions(this.props.match.params.id)
            .then(() => {
                this.setState({
                    options: { ...this.props.options, isProtected: true }
                });
            });

        this.props.fetchDrivers(this.props.match.params.id)
            .then(() => {
                // In case of empty driver open popup
                if (Object.keys(this.props.drivers).length === 0) {
                    this.toggleModalDriverAdd(true);
                }
            });

        // Call a verify of project
        this.props.verifyProject(this.props.match.params.id);
    }

    handleChangeProjectInfo(event) {
        const name = '' + event.target.name;
        const v = '' + event.target.value;
        this.setState({ [name]: v }, () => {
            if (this.projectIsTemporary()) {
                this.props.setTemporaryProject(false).then(() => {
                    addRecentProject(this.getEditedProject());
                })
            } else {
                addRecentProject(this.getEditedProject());
            }
            this.props.updateProject(this.props.match.params.id, this.getEditedProject());
        });
    }

    getEditedProject() {
        return {
            id: this.props.project.id,
            creationDate: this.props.project.creationDate,
            name: this.props.project.name,
            orderCode: this.state.projectOrderCode,
            description: this.state.projectDescription,
            customer: this.state.projectCustomer,
        };
    }

    stopLoader() {
        //stopping loader
        const { t } = this.props;
        this.setState({ saveProjectButtonText: t('Finish_and_download') });
        this.setState({ disabledDriver: false });
        this.setState({ disabledClassName: '' });
        this.setState({ disabled: false });

    }

    toggleModalDriverAdd(isToOpen) {
        this.setState({ isShowingDriverAdd: isToOpen });
    }

    saveAndDownloadProject(skipOpModeCheck = false) {
        if (!skipOpModeCheck) {
            if (this.state.checkedFeatures.includes("om") || this.props.programmingSelection.includes("om")) {
                this.setState({ isShowingWarningOpMode: false })
            } else {
                this.setState({ isShowingWarningOpMode: true })
                return
            }

        } else {
            this.setState({ isShowingWarningOpMode: false })
        }

        if (this.validateConfigLock("saveAndDownload")) {
            this.saveProject();
            this.tryToDownloadProject();
        }
    }

    validateConfigLock(button) {
        this.setState({ lastButtonClicked: button });
        const configLock = this.props.driverProperties.filter((d) => d.info.name === 'key.mp')[0];
        if (configLock) {
            const type = configLock.valueMeta.max === "9999" ? 1 : 2;
            this.setState({ keyType: type, isShowingProgramm: configLock.value === 'Off' });
            if (configLock.value !== 'Off') {
                this.handleCloseModalPassword(true, button);
            }
            return false;
        }
        return true;
    }

    projectIsTemporary() {
        return this.props.projectIsTemporary || (this.props.project && this.props.project.name !== undefined && this.props.project.name !== null && (this.props.project.name.toUpperCase().startsWith("TEMPORARYPROJECT_") || this.props.project.name.toUpperCase().startsWith("TEMPORARYNAME_")));
    }

    saveProject() {
        // If it is temporary and not all properties has been flled show errors
        if (this.projectIsTemporary()) {

        }

        //starting loader
        this.setState({
            saveProjectButtonText:
                <div>
                    <Spinner
                        style={{ marginRight: "0.25rem" }}
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <Trans i18nKey="Downloading" />
                </div>
        });
        this.setState({ disabledDriver: true });
        this.setState({ disabledClassName: "card-disabled" });
        this.setState({ disabled: true });

        //update project data
        if (this.isProjectChanged()) {
            this.props.updateProject(this.props.match.params.id, this.getEditedProject());
        }
    };

    tryToDownloadProject() {

        //download of project
        if (!this.props.validationSummary.isValid) {
            this.setState({ isShowingWarningErrors: true });
        }
        else {
            this.props.generateProject(this.props.match.params.id)
                .then(() => {

                    let isProtected = true;
                    if (this.props.validationSummary && !this.props.validationSummary.isValid) {
                        this.props.validationSummary.messages.forEach(message => {
                            if (message.description === 'DeviceNotProtected' || message.name === 'DeviceNotProtected') {
                                isProtected = false;
                            }
                        });
                    }

                    if (isProtected) {
                        this.downloadProject();
                    } else {
                        //stopping loader
                        this.stopLoader();
                        this.setState({ isShowingWarningDownloadPassword: true });
                    }
                });
        }
    }

    downloadProject() {
        this.props.downloadProject(this.props.match.params.id, this.props.downloadId)
            .then(() => {
                let res = this.props.file;
                let filename = `Project-${this.props.match.params.id}.osrtup`;
                if (res.headers['content-disposition']) {
                    const contentDisposition = res.headers['content-disposition'];
                    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }
                }
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                //stopping loader
                this.stopLoader();
                this.props.setTemporaryProject(false);
                if (localStorage.getItem(X_API_KEY) === undefined || localStorage.getItem(X_API_KEY) === null || localStorage.getItem(X_API_KEY) === '') {

                    removeRecentProject(this.props.match.params.id);
                    this.setState({ isShowingDeleteProjectForDemo: true });
                }
            })
            .catch((error) => {
                //stopping loader
                this.stopLoader();

                if (error.request.status === 403) {
                    this.setState({ isShowingWarningDownloadApiKey: true });
                }
            });
    }

    tryToOpenCopyProjectPopup() {
        if (this.projectIsTemporary()) {
            this.openCopyProjectPopup();

        } else if (this.validateConfigLock("copyProject")) {
            this.openCopyProjectPopup();
        }
    }

    openCopyProjectPopup() {
        //starting loader
        this.setState({ isShowingWarningNewProject: true });
        this.setState({ newProjectNameForCopy: this.props.project.name });
        this.setState({
            copyProjectButtonText:
                <div>
                    <Spinner
                        style={{ marginRight: "0.25rem" }}
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <Trans i18nKey="Saving" />
                </div>
        });
        this.setState({ disabledDriver: true });
        this.setState({ disabledClassName: 'card-disabled' });
        this.setState({ disabled: true });
    };

    copyProject() {

        this.setState({
            saveAsNewProjectModalText: <div>
                <Spinner
                    style={{ marginRight: "0.25rem" }}
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                <Trans i18nKey="Saving_as_new" />
            </div>
        });

        if (this.projectIsTemporary()) {
            const editedProject = this.getEditedProject();
            editedProject.name = this.state.newProjectNameForCopy;
            this.props.updateProject(this.props.match.params.id, editedProject).then(() => {
                this.handleCloseModalNewProject();
                window.location.reload();
            });
        } else {
            this.props.copyProject(this.props.match.params.id, this.state.newProjectNameForCopy)
                .then((id) => {
                    this.handleCloseModalNewProject();

                    this.props.history.push('/projects/' + this.props.project.id + '/driver');
                    window.location.reload();
                    //this.props.history.go('/projects/' + this.props.project.id + '/driver');
                });
        }
    }

    handleChangeNewProjectName(e) {
        this.setState({ newProjectNameForCopy: e.target.value });
    }

    isProjectChanged() {
        return this.props.project.description !== this.state.projectDescription
            // || this.props.project.name !== this.state.projectName
            || this.props.project.orderCode !== this.state.projectOrderCode
            || this.props.project.customer !== this.state.projectCustomer;
    }
    handleChangeOperatingMode(opModeSelect) {
        if (opModeSelect && this.props.driver?.driverId) {
            this.props.updateDriverOpmodesSelected(this.props.match.params.id, this.props.driver.driverId, opModeSelect.id).then(() => {
                this.props.fetchDriverOpmodesSelected(this.props.project.id, this.props.driver.driverId);

                if (this.props.project?.id && this.props.driver?.driverId) {
                    this.props.fetchDriverFeatures(this.props.project.id, this.props.driver.driverId);
                    this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);
                }

            });
        }
    }

    handleCheckedFeatures(checkedFeatures) {
        this.setState({ checkedFeatures: checkedFeatures });
    }

    handleChangeDriverProperties(property) {
        if (property !== null && this.props.driver.driverId) {
            propertiesWorker.postMessage({
                projectId: this.props.project.id,
                driverId: this.props.driver.driverId,
                driverProperties: [property],
            });
        }

        let driverProperties = this.state.driverProperties;
        let index = driverProperties.findIndex((p) => p.id === property.id);
        if (index === -1) {
            driverProperties.push(property);
        }
        else {
            driverProperties[index] = property;
        }
        this.setState({ driverProperties: driverProperties });
    }

    //validate the data
    isValid(value) {
        // if (value === undefined || value === null || value === '') {
        //     return false;
        // }
        // else {
        //     return true;
        // }
        return value !== undefined
            && value !== null
            && value !== '';
    }

    handleCloseModalApiKey() {
        this.setState({ isShowingWarningDownloadApiKey: false });

        //stopping loader
        this.stopLoader();
    }

    handleCloseModalErrors() {
        this.setState({ isShowingWarningErrors: false });

        //stopping loader
        this.stopLoader();
    }

    handleCloseModalDeleteProjectForDemo() {
        this.setState({ isShowingDeleteProjectForDemo: false });

        this.props.history.push('/');
    }

    handleCloseModalPassword(hasToContinue, button = null) {
        this.setState({ isShowingWarningDownloadPassword: false });
        this.setState({ isShowingProgramm: false });

        let lasButton = this.state.lastButtonClicked ? this.state.lastButtonClicked : button;
        if (hasToContinue) {
            //this.handleCloseModalProgrammingOptions();

            switch (lasButton) {
                case "saveAndDownload":
                    this.setState({ isShowingProgrammingOptions: true });
                    break;
                case "copyProject":
                    this.openCopyProjectPopup();
                    break;
                default:
                    break
            }

        } else {
            //stopping loader
            this.stopLoader();
        }
    }

    handleCloseModalNewProject() {
        const { t } = this.props;
        this.setState({ isShowingWarningNewProject: false });
        this.setState({ copyProjectButtonText: !this.projectIsTemporary() ? t('Save_as') : t('Change_project_name') });
        this.setState({ disabledDriver: false });
        this.setState({ disabledClassName: '' });
        this.setState({ disabled: false });
    }

    handleChangeProgrammingOptions(e) {
        const options = this.state.options;

        switch (e.target.name) {
            case "reworkKey":
                options[e.target.name] = e.target.value;
                this.setState({ reworkKeyType: e.target.reworkKeyType })
                break;
            case "programAs":
                // switch b/w master/service
                options[e.target.name] = e.target.id;
                if (this.state.reworkKeyType === "default") {
                    let masterKey = this.props.driverProperties ? this.props.driverProperties.filter((d) => d.info.name === 'key.mp')[0] : null
                    let serviceKey = this.props.driverProperties ? this.props.driverProperties.filter((d) => d.info.name === 'key.sp')[0] : null
                    if (e.target.id === "master") {
                        options["reworkKey"] = masterKey.value
                    } else if (e.target.id === "service") {
                        options["reworkKey"] = serviceKey.value
                    }
                }
                options.isProtected = e.target.id !== "user";
                break;
            default:
                options[e.target.name] = e.target.checked;
                break;
        }

        this.setState({ options: options });
    }

    handleCloseModalProgrammingOptions() {
        this.setState(prevState => ({ isShowingProgrammingOptions: false, options: { ...prevState.options, reworkKey: "" } }));

        this.props.putProjectOptions(this.props.match.params.id, this.state.options)
            .then(() => {
                switch (this.state.lastButtonClicked) {
                    case "saveAndDownload":
                        this.saveProject();
                        this.tryToDownloadProject();
                        break;
                    case "copyProject":
                        this.openCopyProjectPopup();
                        break;
                    default:
                        break
                }
            });

        //stopping loader
        this.stopLoader();
    }

    handleCancelModalProgrammingOptions() {
        this.setState(
            prevState => (
                {
                    isShowingProgrammingOptions: false,
                    options: { ...prevState.options, reworkKey: "" }
                }
            )
        );

        // switch (this.state.lastButtonClicked) {
        //     case "saveAndDownload":
        //         this.saveProject();
        //         this.tryToDownloadProject();
        //         break;
        //     case "copyProject":
        //         this.openCopyProjectPopup();
        //         break;
        //     default:
        //         break
        // }

        //stopping loader
        this.stopLoader();
    }

    componentWillUnmount() {

        if (!this.props.projectIsTemporary && this.props.project && !this.state.isShowingDeleteProjectForDemo) {
            addRecentProject(this.getEditedProject());
        }

        this.props.resetProject();
        this.props.resetDriver();
    }

    render() {

        // if(this.props.errors === 404) {
        //     this.props.history.push('/404');
        // }

        if (!this.props.match.params.id || !this.props.project) {
            return (<ProjectPlaceholder />);
        }

        const { t } = this.props;

        return (
            <Router>
                <ProjectHeader
                    project={this.props.project}
                    projectName={this.props.project.name}
                    handleChangeProjectInfo={this.handleChangeProjectInfo}
                    handleAddDriver={() => this.toggleModalDriverAdd(true)}
                    driver={this.props.driver}
                    disabled={this.state.disabled}
                    saveProject={() => this.saveAndDownloadProject()}
                    saveProjectButtonText={this.state.saveProjectButtonText}
                    copyProject={this.tryToOpenCopyProjectPopup}
                    copyProjectButtonText={this.state.copyProjectButtonText} />

                <Switch>
                    <Route path="/projects/:id/driver/:driverId" render={
                        (routeProps) => (
                            <ProjectDriver {...routeProps}
                                disabledDriver={this.state.disabledDriver}
                                disabledClassName={this.state.disabledClassName}
                                project={this.props.project}
                                driver={this.props.driver}
                                drivers={this.props.drivers}
                                projectErrors={this.state.projectErrors}
                                driverId={routeProps.match.params.driverId}

                                projectName={this.props.project.name}
                                projectOrderCode={this.state.projectOrderCode}
                                projectDescription={this.state.projectDescription}
                                projectCustomer={this.state.projectCustomer}
                                handleChangeProjectInfo={this.handleChangeProjectInfo}

                                handleChangeOperatingMode={this.handleChangeOperatingMode}
                                handleCheckedFeatures={this.handleCheckedFeatures}
                                handleChangeDriverProperties={this.handleChangeDriverProperties}
                                openAddDriver={() => this.toggleModalDriverAdd(true)} />
                        )
                    } />
                    <Route path="/projects/:id/driver" render={
                        (routeProps) => (
                            <ProjectDriver {...routeProps}
                                disabledDriver={this.state.disabledDriver}
                                disabledClassName={this.state.disabledClassName}
                                project={this.props.project}
                                driver={this.props.driver}
                                drivers={this.props.drivers}
                                projectErrors={this.state.projectErrors}

                                projectName={this.props.project.name}
                                projectOrderCode={this.state.projectOrderCode}
                                projectDescription={this.state.projectDescription}
                                projectCustomer={this.state.projectCustomer}
                                handleChangeProjectInfo={this.handleChangeProjectInfo}

                                handleChangeOperatingMode={this.handleChangeOperatingMode}
                                handleCheckedFeatures={this.handleCheckedFeatures}
                                handleChangeDriverProperties={this.handleChangeDriverProperties}
                                openAddDriver={() => this.toggleModalDriverAdd(true)} />
                        )
                    } />
                    <Route path="/projects/:id/summary" render={
                        (routeProps) => (
                            <ProjectSummary {...routeProps}
                                project={this.props.project}
                                driver={this.props.driver} />
                        )
                    } />
                </Switch>

                <Modal show={this.state.isShowingWarningOpMode} onHide={() => this.setState({ isShowingWarningOpMode: false })} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Warning" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans i18nKey="Operation_Mode_Not_Programmed" />
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.saveAndDownloadProject(true)}><Trans i18nKey="Continue" /></Button>
                        <Button variant="secondary" onClick={() => this.setState({ isShowingWarningOpMode: false })}><Trans i18nKey="Cancel" /></Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.isShowingWarningDownloadApiKey} onHide={this.handleCloseModalApiKey} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Warning" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans i18nKey="Download_API_Key_Warning_Full" />
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModalApiKey}><Trans i18nKey="Ok" /></Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.isShowingProgramm} onHide={() => this.handleCloseModalPassword(false)} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Warning" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans i18nKey="You_have_not_set_up_a_password_line_1" /><br />
                            <Trans i18nKey="You_have_not_set_up_a_password_line_2" /><br />
                            <Trans i18nKey="You_have_not_set_up_a_password_line_3" />
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" style={{ marginRight: "0" }} onClick={() => this.handleCloseModalPassword(true)}><Trans i18nKey="Continue_anyways" /></Button>
                        <Button variant="secondary" onClick={() => this.handleCloseModalPassword(false)}><Trans i18nKey="Cancel" /></Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.isShowingProgrammingOptions} onHide={() => this.setState(prevState => ({ isShowingProgrammingOptions: false, options: { ...prevState.options, reworkKey: "" } }))} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Programming_Options" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Group as={Col} sm="12" controlId="name">
                            <p style={{ marginBottom: "0.5rem" }}>
                                <Trans i18nKey="Program_As" />
                            </p>
                            <div style={{ paddingBottom: "0.5rem", display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex" }}>
                                    <Radio
                                        name="programAs"
                                        id="master"
                                        checked={this.state.options.programAs === "master"}
                                        onClick={this.handleChangeProgrammingOptions.bind(this)}
                                        onChange={this.handleChangeProgrammingOptions.bind(this)}
                                    />
                                    <p style={{ margin: "auto" }}>
                                        <Trans i18nKey="Master" />
                                    </p>
                                </div>

                                <div style={{ display: "flex" }}>
                                    <Radio
                                        name="programAs"
                                        id="service"
                                        checked={this.state.options.programAs === "service"}
                                        onClick={this.handleChangeProgrammingOptions.bind(this)}
                                        onChange={this.handleChangeProgrammingOptions.bind(this)}
                                    />
                                    <p style={{ margin: "auto" }}>
                                        <Trans i18nKey="Service" />
                                    </p>
                                </div>

                                <div style={{ display: "flex" }}>
                                    <Radio
                                        name="programAs"
                                        id="user"
                                        checked={this.state.options.programAs === "user"}
                                        onClick={this.handleChangeProgrammingOptions.bind(this)}
                                        onChange={this.handleChangeProgrammingOptions.bind(this)}
                                    />
                                    <p style={{ margin: "auto" }}>
                                        <Trans i18nKey="User" />
                                    </p>
                                </div>
                            </div>

                            {this.state.options.programAs !== "user" && (
                                <>
                                    <div style={{ paddingBottom: "0.5rem" }}>
                                        <Form.Check
                                            disabled={this.state.options.programAs === "user"}
                                            label={t('If_target_driver_is_protected')}
                                            required
                                            name="isProtected"
                                            type="checkbox"
                                            checked={this.state.options.isProtected}
                                            onChange={this.handleChangeProgrammingOptions.bind(this)} />
                                    </div>

                                    <ReworkKeyForm
                                        disabled={!this.state.options.isProtected}
                                        selectedMode={this.state.options.programAs}
                                        property={this.state.options.reworkKey}
                                        type={this.state.keyType}
                                        propertyObject={this.props.driverProperties ? this.props.driverProperties.filter((d) => d.info.name === 'key.mp')[0] || null : null}
                                        propertyObjectS={this.props.driverProperties ? this.props.driverProperties.filter((d) => d.info.name === 'key.sp')[0] || null : null}
                                        numberOfKeys={4}
                                        handleChange={this.handleChangeProgrammingOptions.bind(this)} />
                                </>
                            )}

                            <Form.Check
                                label={t('Verify_parameters_after_programming')}
                                required
                                name="verify"
                                type="checkbox"
                                checked={this.state.options.verify}
                                onChange={this.handleChangeProgrammingOptions.bind(this)} />

                            <Form.Check
                                label={t('Disable_Family_Programming')}
                                required
                                name="disableFamilyProgramming"
                                type="checkbox"
                                checked={this.state.options.disableFamilyProgramming}
                                onChange={this.handleChangeProgrammingOptions.bind(this)} />

                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleCloseModalProgrammingOptions}><Trans i18nKey="Save" /></Button>
                        <Button variant="secondary" onClick={this.handleCancelModalProgrammingOptions}><Trans i18nKey="Cancel" /></Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.isShowingWarningNewProject} onHide={this.handleCloseModalNewProject} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}>{!this.projectIsTemporary() ? <Trans i18nKey="Save_as" /> : <Trans i18nKey="Change_project_name" />}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Group as={Col} md="12" controlId="name">
                            <Form.Label><Trans i18nKey="New_Project_name" /></Form.Label>
                            <Form.Control
                                required
                                name="project"
                                type="text"
                                value={this.state.newProjectNameForCopy}
                                onChange={this.handleChangeNewProjectName}
                                placeholder={t('Project_name_placeholder')}
                            />
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={this.copyProject}>{this.state.saveAsNewProjectModalText}</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.isShowingWarningErrors} onHide={this.handleCloseModalErrors} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#FF6600" }}><Trans i18nKey="Error" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans i18nKey="Download_Errors_Warning" />
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModalErrors}><Trans i18nKey="Ok" /></Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.isShowingDeleteProjectForDemo} onHide={this.handleCloseModalDeleteProjectForDemo} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#FF6600" }}><Trans i18nKey="Warning" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p style={{ color: "#ff0000" }}><b><Trans i18nKey="Public_Mode_Project_Deleted" /></b></p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModalDeleteProjectForDemo}><Trans i18nKey="Ok" /></Button>
                    </Modal.Footer>
                </Modal>

                <DeviceSelect
                    isShowed={this.state.isShowingDriverAdd}
                    handleCloseModal={() => this.toggleModalDriverAdd(false)} />
            </Router>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        project: state.project.info,
        projectIsTemporary: state.project.isTemporary,
        drivers: state.drivers,
        driver: state.driver.info,
        downloadId: state.project.downloadId,
        file: state.project.file,
        validationSummary: state.project.validationSummary,
        errors: state.errorsHandler.errors,
        programmingSelection: state.driver.programmingSelection,
        notFound: state.errorsHandler.notFound,
        options: state.project.options,
        driverProperties: state.driver.properties
    };
};

const mapDispatchToProps = {
    copyProject,
    fetchProject,
    fetchDrivers,
    fetchDriverProperties,
    fetchDriverFeatures,
    fetchDriverOpmodesSelected,
    generateProject,
    updateProject,
    verifyProject,
    downloadProject,
    updateDriverOpmodesSelected,
    resetProject,
    resetDriver,
    setTemporaryProject,
    getProjectOptions,
    putProjectOptions
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(Project);
